<template>
    <footer class="footer has-cards">
        <div class="container">
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}} <span>www.orchard-biotech.com all right reserve</span>
                    </div>
                </div>
                <div class="col-md-6 pb-3 pb-md-0">
                  <div class="text-left text-md-right">
                    <small>
                      Orchard Group Biotech Limited <br />
                      ICBC (中國工商銀行)<br />
                      港幤 868-520-01917-9<br />
                      外幤 868-530-00747-2
                    </small>
                  </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
  @media screen and (max-width: 768px) {    
    .footer .row{
      flex-direction: column-reverse;
    }
  }
</style>
